module.exports = __webpack_public_path__ + "img/url-link-svgrepo-com.e76aed8a.svg";